export function formatThaiNumber(num: number): string {
  const units = [
    { value: 1_000_000_000, label: "พันล้าน" },
    { value: 1_000_000, label: "ล้าน" },
    { value: 100_000, label: "แสน" },
    { value: 10_000, label: "หมื่น" },
    { value: 1_000, label: "พัน" },
  ];

  for (const unit of units) {
    if (num >= unit.value) {
      const formatted = (num / unit.value).toFixed(1);
      return `${parseFloat(formatted)} ${unit.label}`;
    }
  }

  return num.toLocaleString("th-TH");
}
